import { Outlet } from "react-router-dom";
import { useAudit } from "../context/AuditContext";
import { Button } from "./ui/button";
import Sidebar from "./Sidebar";
import Header from "./Header";
import ChatPanel from "./ChatPanel";
import { MessageCircle, Sparkles } from "lucide-react";

export default function Layout() {
  const { chatOpen, setChatOpen } = useAudit();

  return (
    <div className={`audit-layout ${!chatOpen ? 'chat-closed' : ''}`} data-testid="audit-layout">
      <div className="audit-sidebar">
        <Sidebar />
      </div>
      <div className="audit-header">
        <Header />
      </div>
      <div className="audit-main p-6 ambient-canvas">
        <div className="ambient-orb orb-one" />
        <div className="ambient-orb orb-two" />
        <div className="ambient-particles" />
        <Outlet />
        {!chatOpen && (
          <Button
            onClick={() => setChatOpen(true)}
            className="floating-ai-btn"
            aria-label="Open AI assistant"
            title="Open AI Assistant"
          >
            <MessageCircle className="w-4 h-4" />
            <span>AI Assistant</span>
            <Sparkles className="w-3.5 h-3.5 ai-sparkle" />
          </Button>
        )}
      </div>
      {chatOpen && (
        <div className="audit-chat">
          <ChatPanel />
        </div>
      )}
    </div>
  );
}
